export const POSTHOG_FEATURE_FLAGS = {
  enabledManageUsersAdminsNewLogic: "enable-manage-users-admins-new-logic",
  enabledPaymentsFilterBank: "enable-payments-filter-bank",
  enableNewTransactionSigningFlow: "enable-new-transaction-signing-flow",
  fxPayouts: "fx-payouts",
  enableUsersCsvExport: "enable-users-csv-export",
  javaAccounts: "java-accounts",
  javaHideConnect: "java-hide-connect",
  javaNamedAccounts: "java-named-accounts",
};
